import React, { useCallback, useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const previewImages = [{
  src: 'https://cdn.magicpatterns.com/uploads/fXQ9NcALw28DBXcBhHeUva/3-Tu-semana-resuelta-menu-de-4-comidas-por-dia.png',
  alt: 'Menú semanal completo con 4 comidas por día',
  label: 'Menú semanal'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/jjCveQUPU7QBmVfHtda41D/2_Receta-14-Albondigas-de-Pollo-y-Zanahoria-con-Salsa-Suave-de-Tomate.png',
  alt: 'Receta de Albóndigas de Pollo y Zanahoria',
  label: 'Recetas deliciosas'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/kGrRLfVzULmT7qmjTFKyyo/1_Receta-4-Granola-Casera-Low-FODMAP-Crocante.png',
  alt: 'Receta de Granola Casera Low FODMAP',
  label: 'Desayunos saludables'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/c2CpqBHSqLpXTpUTVSJDsN/4-Tu-compra-resuelta-lista-simple-para-el-super.png',
  alt: 'Checklist semanal - Lista de compras',
  label: 'Lista de compras'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/r4fsSsa8zmaFBdzjamqomG/6-Panificados-y-Masa-Madre-sin-Inflamacion.png',
  alt: 'Panificados y Masa Madre sin inflamación',
  label: 'Panificados y masa madre'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/pbsDCat6sUX2ebQiH7qTja/1_Receta-22-Muffins-Sin-Gluten.png',
  alt: 'Receta de Muffins Sin Gluten',
  label: 'Muffins sin gluten'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/fWmQLoB6DWQZxxrZJdDbXu/2_Receta-38-Berenjenas-Rellenas-Gratinadas-Sin-Harina.png',
  alt: 'Receta de Berenjenas Rellenas Gratinadas Sin Harina',
  label: 'Berenjenas rellenas gratinadas'
}];
export function ProductPreview() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const nextSlide = useCallback(() => {
    setCurrentIndex(prev => prev === previewImages.length - 1 ? 0 : prev + 1);
  }, []);
  const prevSlide = () => {
    setCurrentIndex(prev => prev === 0 ? previewImages.length - 1 : prev - 1);
    setIsAutoPlaying(false);
  };
  const handleNextClick = () => {
    nextSlide();
    setIsAutoPlaying(false);
  };
  useEffect(() => {
    let interval: ReturnType<typeof setInterval>;
    if (isAutoPlaying) {
      interval = setInterval(nextSlide, 4000);
    }
    return () => clearInterval(interval);
  }, [isAutoPlaying, nextSlide]);
  return <section className="py-12 sm:py-16 lg:py-20 bg-brand-bg-cream" data-id="element-143">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-144">
        <div className="text-center mb-12" data-id="element-145">
          <motion.h2 className="text-3xl sm:text-4xl font-playfair font-bold text-brand-text-dark mb-4" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-146">
            Mirá cómo es el plan{' '}
            <span className="italic text-brand-green" data-id="element-147">por dentro</span>
          </motion.h2>
          <div className="w-24 h-1 bg-brand-green-light mx-auto rounded-full mb-6" data-id="element-148"></div>
          <p className="text-lg text-brand-text-medium max-w-2xl mx-auto" data-id="element-149">
            Todo organizado para que no tengas que pensar. Desde el menú semanal
            hasta la lista del súper.
          </p>
        </div>

        <div className="relative" data-id="element-150">
          {/* Navigation arrows */}
          <button onClick={prevSlide} className="absolute top-1/2 -translate-y-1/2 left-2 sm:-left-6 z-10 bg-white/90 backdrop-blur-sm p-2.5 sm:p-3 rounded-full shadow-lg border border-gray-100 text-brand-green hover:bg-brand-bg-cream transition-colors" aria-label="Imagen anterior" data-id="element-151">
            <ChevronLeft className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-152" />
          </button>

          <button onClick={handleNextClick} className="absolute top-1/2 -translate-y-1/2 right-2 sm:-right-6 z-10 bg-white/90 backdrop-blur-sm p-2.5 sm:p-3 rounded-full shadow-lg border border-gray-100 text-brand-green hover:bg-brand-bg-cream transition-colors" aria-label="Siguiente imagen" data-id="element-153">
            <ChevronRight className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-154" />
          </button>

          {/* Image display */}
          <div className="overflow-hidden rounded-3xl bg-white shadow-2xl border-4 border-white" data-id="element-155">
            <div className="relative aspect-[3/4] sm:aspect-[4/5] md:aspect-[3/4] lg:aspect-[4/5] max-h-[600px]" data-id="element-156">
              <AnimatePresence mode="wait" data-id="element-157">
                <motion.div key={currentIndex} initial={{
                opacity: 0,
                scale: 0.98
              }} animate={{
                opacity: 1,
                scale: 1
              }} exit={{
                opacity: 0,
                scale: 0.98
              }} transition={{
                duration: 0.4
              }} className="absolute inset-0" data-id="element-158">
                  <img src={previewImages[currentIndex].src} alt={previewImages[currentIndex].alt} className="w-full h-full object-contain bg-brand-bg-cream p-2" data-id="element-159" />
                </motion.div>
              </AnimatePresence>
            </div>

            {/* Label bar */}
            <div className="bg-brand-green py-3 px-6 text-center" data-id="element-160">
              <span className="text-white font-poppins font-semibold text-sm sm:text-base" data-id="element-161">
                {previewImages[currentIndex].label}
              </span>
            </div>
          </div>

          {/* Dot indicators */}
          <div className="flex justify-center gap-2 mt-6" data-id="element-162">
            {previewImages.map((_, index) => <button key={index} onClick={() => {
            setCurrentIndex(index);
            setIsAutoPlaying(false);
          }} className={`w-2.5 h-2.5 rounded-full transition-all ${index === currentIndex ? 'bg-brand-green w-6' : 'bg-brand-green/30'}`} aria-label={`Ver imagen ${index + 1}`} data-id="element-163" />)}
          </div>
        </div>
      </div>
    </section>;
}